"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var asset_accessor_1 = require("./asset-accessor");

exports.defaultFallbackImage = 'data:image/png;base64,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';
exports.fallbackFluid = {
  aspectRatio: 1
};
exports.fallbackFixed = {
  aspectRatio: 1,
  width: 16,
  height: 16
};

function getFallbackImageObject(baseObject, fallbackImage) {
  var fallbackObject = __assign({}, baseObject);

  if (fallbackImage) {
    fallbackObject.base64 = fallbackImage;
    fallbackObject.src = fallbackImage;
    return fallbackObject;
  }

  return undefined;
}

function createFallbackFluidImageObject(fallbackImage) {
  return getFallbackImageObject(exports.fallbackFluid, fallbackImage);
}

exports.createFallbackFluidImageObject = createFallbackFluidImageObject;

function createFallbackFixedImageObject(fallbackImage) {
  return getFallbackImageObject(exports.fallbackFixed, fallbackImage);
}

exports.createFallbackFixedImageObject = createFallbackFixedImageObject; // TODO: should be moved to a 'utils' / 'helper' file

exports.removeFileExtension = function (fileName) {
  var regex = new RegExp('(.jpg|.jpeg|.png|.svg|.gif)');
  return fileName.replace(regex, '');
}; // TODO: this should come direct from @lsg nodae module


exports.lsgBreakpoints = [640, 1024, 1196, 1680];

exports.generateSrcSet = function (url, originalWidth) {
  var bps = originalWidth ? __spread(exports.lsgBreakpoints.filter(function (el) {
    return el < originalWidth;
  }), [originalWidth]) : exports.lsgBreakpoints;
  return bps.map(function (el) {
    return url + "?w=" + el + "&fit=thumb " + el + "w";
  }).join(',');
};

function getAssetTypeFromMimeType(mimeType) {
  if (mimeType.startsWith('video')) {
    return asset_accessor_1.AssetType.VIDEO;
  }

  if (mimeType.startsWith('image')) {
    return asset_accessor_1.AssetType.IMAGE;
  }

  return asset_accessor_1.CommonAccessorType.UNKNOWN;
}

exports.getAssetTypeFromMimeType = getAssetTypeFromMimeType;

function createQueryableAspectRatioFromString(input) {
  if (typeof input === 'undefined') {
    return undefined;
  }

  var _a = __read(input.split(':').map(function (dimension) {
    return dimension.trim();
  }), 2),
      width = _a[0],
      height = _a[1];

  return "image_" + width + "to" + height;
}

exports.createQueryableAspectRatioFromString = createQueryableAspectRatioFromString; // NOTE/TODO(benjamin): Inline entry nodes contain localized fields which
// currently are not handled by accessors. The following code is written
// under the assumption that there is only one localization configured, which
// means it won't work in a multi-localization environment.

function readDefaultLocalizationFrom(accessorField) {
  var defaultLocalization = Object.keys(accessorField || {})[0];
  return accessorField[defaultLocalization];
}

exports.readDefaultLocalizationFrom = readDefaultLocalizationFrom;